import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

/**
 * API xử lý lấy notify smart
 */
class NotifySmartAPI extends BaseAPI {}

export default new NotifySmartAPI('v1/notify-smart', 'NotifySmart', getApiUrl(apis.CommonAPI))
